import React, { createContext, useContext, useRef } from "react";

const VideoManagerContext = createContext();

export const VideoManagerProvider = ({ children }) => {
  const videoRefs = useRef([]);

  const registerVideo = (video) => {
    if (!videoRefs.current.includes(video)) {
      videoRefs.current.push(video);
    }
  };

  const muteAllExcept = (currentVideo) => {
    videoRefs.current.forEach((video) => {
      if (video !== currentVideo) {
        video.muted = true;
      }
    });
  };

  return (
    <VideoManagerContext.Provider value={{ registerVideo, muteAllExcept }}>
      {children}
    </VideoManagerContext.Provider>
  );
};

export const useVideoManager = () => {
  const context = useContext(VideoManagerContext);
  if (!context) {
    throw new Error("useVideoManager must be used within a VideoManagerProvider");
  }
  return context;
};
